import React, {useState, useEffect} from 'react';
import {taskActions, userActions, facilityActions,taskTypesActions, useSelector} from "inbooma-api";
import {Biscuit, getAllUrlParams} from "../../../../utils";
import t from "../../../helpers/t";
import {$} from "../../../../../vendor";
import TaskSidebar from "./TaskSidebar";
import SortNav from "../../../components/SortNav";
import ItemView from "./ItemView";
import {rbac} from "../index";
import TasksList from "./TasksList";
import * as Functions from "./Functions";
import Loader from "../../../components/Loader";
import Paginator from "../../../components/paginator";
import InboomaSubmenu from "../../../components/InboomaSubmenu";
import moment from "moment/moment";
import {in_array} from "../../../../utils/Helper";
import MultiEditDialog from "../../../components/MultiEditDialog";

const TasksView = (props) => {
    const currentUrl = new URL(window.location.href)
    const searchParams = currentUrl.searchParams;
    const allUrlParams = getAllUrlParams(window.location.href);
    const allUrlParamsClone = {...allUrlParams};
    const [paginationLimit,setPaginationLimit] = useState(50);
    const [extraUsers, setExtraUsers] = useState([]);
    const page = (typeof allUrlParams?.page !== 'undefined' ? allUrlParams?.page : null);
    const status = (typeof allUrlParams?.status !== 'undefined' ? allUrlParams?.status : 'open');
    const [sort,setSort] = useState({
        sort: typeof allUrlParams.sort !== 'undefined'?allUrlParams.sort:'created',
        direction: typeof allUrlParams.direction !== 'undefined'?allUrlParams.direction:'desc'
    })
    const [filters, setFilters] = useState(function () {
        let f = {'includes': 'Users','sort': sort.sort,'direction': sort.direction,'limit': paginationLimit};
        if(status === 'open'){
            f.find = '!Done';
        }
        if(page !== null){
            f.page=page;
        }
        return f;
    });
    const language = Biscuit.get('user.lang').replace('-','_');
    const _tasks = useSelector(state => state["tasks"].tasks);
    const _task_types = useSelector(state => state["task_types_data"].taskTypes);
    const _task = useSelector(state => state["tasks"].task);
    const _bulk = useSelector(state => state["tasks"].bulk);
    const _facilities = useSelector(state => state["facilities"].facilities);
    const _user = useSelector(state => state["users_data"].user);
  //  const _users = useSelector(state => state["users_data"].users);
  //  const [users,setUsers] = useState([]);                 // contains user ids and status for future requests
    const [userQueue,setUserQueue] = useState([]);                 // contains user ids and status for future requests
    const [tasks,setTasks] = useState([]);
    const [taskTypes,setTaskTypes] = useState([]);
    const [task,setTask] = useState({});
    const [facilities,setFacilities] = useState([]);
    const [tasksPending,setTasksPending] = useState(false);
    const [taskTypesPending,setTaskTypesPending] = useState(false);
    const [bulkPending,setBulkPending] = useState(false);
    const [taskPending,setTaskPending] = useState(false);
    const _taskSummary = useSelector(state => state["tasks"].getTaskSummary);
    const [summaryPending, setSummaryPending] = useState(false);
    const [summary,setSummary] = useState([]);
    const [facilitiesPending,setFacilitiesPending] = useState(false);
    const [initialized,setInitialized] = useState(false);
    const [resetFilter,setResetFilter] = useState(false);
    const [action, setAction] = useState(null);
    const [pagination,setPagination] = useState({
        has_next_page: false,
        current_page: 1
    });
    const [checkedItems, setCheckedItems] = useState(function () {
        let checked = [], response ={};
        if(typeof allUrlParams.selected !== 'undefined'){
            let params = allUrlParams.selected;
            checked = params.split('k');
        }
        if(checked.length < 1){
            return {};
        }
        checked.map(c => {
            response[c] = true;
        });
        return response;
    });
    const [selectedItems, setSelectedItems] = useState(function () {
        let checked = []
        if(typeof allUrlParams.selected !== 'undefined'){
            let params = allUrlParams.selected;
            checked = params.split('k');
        }
        return checked.length;
    });
    const [allSelected, setAllSelected] = useState((typeof allUrlParams.selectedall !== 'undefined'?allUrlParams.selectedall:false));
    const [oneItemChecked, setOneItemChecked] = useState(function () {
        let checked = []
        if(typeof allUrlParams.selected !== 'undefined'){
            let params = allUrlParams.selected;
            checked = params.split('k');
        }
        if(checked.length > 0){
            return true;
        }
        return false;
    });
    const [showMultiEditDialog, setShowMultiEditDialog] = useState((typeof allUrlParams.multiedit !== 'undefined'?allUrlParams.multiedit:false));
    const [shouldSave, setShouldSave] = useState(false);
    const fields = ['assignee', 'status', 'end'];
    const fieldTypes = {assignee: 'select', status: 'select', end: 'date'};
    const hasSuperSelect = {assignee: 'User'};
    const selectFields = {assignee: [], status: [ { label: t('new', null, 'capital'), key: 'new' },
    {
        label: t('in_progress', null, 'capital'),
            key: 'inprogress'
    },
    { label: t('done', null, 'capital'), key: 'done' }]};
    const fieldLabels = {assignee: t('assigned', null, 'capital'), status:t('status', null, 'capital'),end:t('done_until') + ' ' + t('till')};

/*
    useEffect(() => {
        if(_users.success === "" || !usersPending){
            return;
        }
        if(_users.success === true){
            let us = [];
            _users.data.map(use => {
                us.push({key:use.id, label:use.last_name+', '+use.first_name});
            });
            setUsers(us);
        }
        setUsersPending(false);
    },[_users])
*/

    useEffect(() => {
        if(bulkPending || !shouldSave){
            return;
        }
        if(shouldSave){
            multiEdit();
        }
    },[shouldSave]);

    const handleCloseDialog = () => {
        setShowMultiEditDialog(false);
        searchParams.delete('multiedit');
        const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
        history.pushState(null, "", newRelativePathQuery);
        if(!shouldSave) {
            window.location.replace(newRelativePathQuery);
        }
    }
    const loadNextPage = (page) => {

       // if (!pagination.has_next_page) return;

        setTasksPending(true);
        // request next page
        let filter = {};
        Object.assign(filter, filters);
        filter.sort= sort.sort;
        filter.direction = sort.direction;
        filter.includes = 'Users';

        if(typeof filter['multiselect'] !== 'undefined'){
            delete(filter['multiselect']);
        }
        if(typeof filter['selected'] !== 'undefined'){
            delete(filter['selected']);
        }
        setFilters(filter);
        if(page > 1){
            searchParams.set('page', page);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        } else{
            searchParams.delete('page');
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
        }
        props.dispatch(taskActions.getTasks({
            token: Biscuit.get('token'),
            filter: {
                ...filter,
                page: page,
                limit: paginationLimit
            },
            parameters: {
                headers: {
                    "Accept-Language": language
                }
            }
        }));
    };

    const _checkUserQueue = () => {

        if (userQueue.length > 0) {

            let hasChanged = false;
            let clone = [...userQueue];

            for (let i=0;i<clone.length;i++) {
                if (clone[i].status === 'new') {
                    clone[i].status = 'pending';
                    hasChanged = true;
                    // fetch user
                    props.dispatch(userActions.getUser({
                        token: Biscuit.get('token'),
                        id: clone[i].id,
                        parameters: {
                            headers: {
                                "Accept-Language": language,
                                "Content-Language": language
                            }
                        }
                    }));
                    break;
                } else if (clone[i].status === 'pending') break;
            }

            if (hasChanged) setUserQueue(clone);
        }
    };

    const userReady = () => {

        for (let i=0;i<userQueue.length;i++) {
            if (userQueue[i].status === 'new' || userQueue[i].status === 'pending') return false;
        }
        return true;
    };

    _checkUserQueue();

    useEffect(() => {

        if (_user.success === "") {            // true or false no matter if a new task is created or an existing task modified
            return;
        }

        let clone;
        if (_user.success === true) {

            let known = false;
            for (let i=0;i<extraUsers.length;i++) {
                if (extraUsers[i].id === _user.data.id) known = true;
            }
            if (!known) {

                clone = [...extraUsers];
                clone.push({..._user.data});
                setExtraUsers(clone);

                let clone2 = [...userQueue];
                for (let i=0;i<clone2.length;i++) {
                    if (clone2[i].status === "pending") {
                        clone2[i].status = "success";
                        break;
                    }
                }
                setUserQueue(clone2);
            }
        } else {
            clone = [...userQueue];
            for (let i=0;i<clone.length;i++) {
                if (clone[i].status === "pending") {
                    clone[i].status = "failed";
                    break;
                }
            }
            setUserQueue(clone);
        }

    },[_user]);

    useEffect(() => {
        if(_task_types.success === "" || !taskTypesPending){
            return;
        }
        if(_task_types.success === true){
            setTaskTypes(_task_types.data);
        }
        setTaskTypesPending(false);
    },[_task_types])

    useEffect(() => {
        if (_tasks.success === "") return;

        if (_tasks.success === true) {
            setTasks(_tasks.data);
            setPagination({..._tasks.pagination});

        } else {
            console.log("Failed to request tasks!");
        }
        setTasksPending(false);
        if(!taskPending && !facilitiesPending && !summaryPending) {
            setInitialized(true);
        }
    },[_tasks]);

    useEffect(() => {
        if (_task.success === "") return;

        if (_task.success === true) {
                setTask(_task.data);
        } else {
            console.log("Failed to request task!");
        }
        setTaskPending(false);
        props.dispatch(taskActions.resetTask());
        if(!tasksPending && !facilitiesPending && !summaryPending) {
            setInitialized(true);
        }
    },[_task]);

    useEffect(() => {
        if (summaryPending === false || _taskSummary.success === "") {
            return;
        }
        if (_taskSummary.success === true) {
            setSummary(_taskSummary.data);
        } else {
            console.log("Failed fetching summary!");
        }
        setSummaryPending(false);
        if(!tasksPending && !taskPending && !facilitiesPending){
            setInitialized(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[_taskSummary]);

    useEffect(() => {
        if (_facilities.success === "") return;

        if (_facilities.success === true) {
            setFacilities(_facilities.data);
        } else {
            console.log("Failed to request facilities!");
        }
        setFacilitiesPending(false);
        if(!tasksPending && !taskPending && !summaryPending) {
            setInitialized(true);
        }
    },[_facilities]);

    useEffect(() => {
        if (_bulk.success === "" || !bulkPending || action === null) return;

        if (_bulk.success === true) {
            onFilterChanged(filters);
            let str = t(action);
            const f = str.charAt(0).toLowerCase()
            let newStr = f + str.substr(1)
            props.showNotification('success',null, _bulk.data.length + " "+ t('tasks') + " " + newStr +'.')
        } else {
            console.log("Failed to request bulk!");
        }
        setBulkPending(false);
        setAction(null);
    },[_bulk]);

    useEffect(() => {
        if(tasksPending || summaryPending) return;
        props.dispatch(taskActions.getTaskSummary({
            token: Biscuit.get('token'),
            filter: filters,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setSummaryPending(true);
        if(!tasksPending && !taskPending && !facilitiesPending){
            setInitialized(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[tasks]);

    const onCloseTask = () => {
        props.dispatch(taskActions.resetTask());
        let returnUrl = '/tasks';
        window.location.replace(returnUrl);
    };

    const onRemoveTask = (task) => {
        if (confirm(t('really_remove'))) {
            props.dispatch(taskActions.deleteTask(
                {
                    id: Number(task.id),
                    token: Biscuit.get('token'),
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }
            ));
            setTaskPending(true);
        }
    };

    const onChangeItemStatus = (e,task) => {

        props.dispatch(taskActions.editTask({
            body: {
                status: e.target.value,
                all_roles: true,
                images: task.images
            },
            id: Number(task.id),
            token: Biscuit.get('token'),
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setTaskPending(true);
    };

    const onFilterChanged = (filter) => {
        if(typeof filter['multiselect'] !== 'undefined'){
            delete(filter['multiselect']);
        }
        if(typeof filter['selected'] !== 'undefined'){
            delete(filter['selected']);
        }
        setFilters(filter);
        props.dispatch(taskActions.getTasks({
            token: Biscuit.get('token'),
            filter: {...filter,
                limit: paginationLimit,
                page: 1
            },
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setTasksPending(true);
    };

    const onChangeSort = (ev) => {

        const el = ev.currentTarget;

        let sortKey = el.getAttribute('data-inb-val'),
            direction = el.getAttribute('data-inb-direction'),
            isOppositeElement = (direction === null && el.classList.contains('is-active')),
            newDirection = (direction === 'desc' || isOppositeElement ? 'asc' : 'desc');
        if(direction === null){
            // first hit, no content, should be desc
            direction = 'desc';
        }
        if (sortKey) {
            let filter = {};
            Object.assign(filters, filter);
            filter.sort= sortKey;
            filter.direction = direction;
            setSort({sort: sortKey, direction: direction});
            searchParams.set('sort', sortKey);
            searchParams.set('direction', direction);
            const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
            history.pushState(null, "", newRelativePathQuery);
            filter.includes = 'Users';

           if(typeof filter['multiselect'] !== 'undefined'){
                delete(filter['multiselect']);
            }
            if(typeof filter['selected'] !== 'undefined'){
                delete(filter['selected']);
            }
            setFilters(filter);
            props.dispatch(taskActions.getTasks({
                token: Biscuit.get('token'),
                filter: filter,
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setTasksPending(true);
            const activeSortTab = $('.is-active');

            for (let tab=0;tab<activeSortTab.length;tab++) {
                activeSortTab[tab].classList.remove('is-active');
            }
            /*
            _.each(activeSortTab, function(key,value){
              key.classList.remove('is-active');
            });
            */
            el.classList.add('is-active');
            el.setAttribute('data-inb-direction', (isOppositeElement ? 'desc' : newDirection));
        }
    };

    const initialize = () => {
        if(initialized || tasksPending || taskPending || facilitiesPending || summaryPending){
            return true;
        }
        props.dispatch(taskActions.resetTask());
        let requestFilter = {...filters};
        if(props["params"].assignee !== null){
            requestFilter ={...requestFilter,assignee:props["params"].assignee};
        }
        if(props["params"].resId !== null){
            requestFilter ={...requestFilter,id:props["params"].resId};
        }
        if(typeof requestFilter['multiselect'] !== 'undefined'){
            delete(requestFilter['multiselect']);
        }
        if(typeof requestFilter['selected'] !== 'undefined'){
            delete(requestFilter['selected']);
        }
        Object.keys(props['params']).map((val) =>{
            if(!in_array(val,['add','assignee','resId','returnPath','fk_model','fk_id','lead','id'])){
                if(props['params'][val] !== 'all') {
                    requestFilter[val] = props['params'][val];
                }
            }
        });
        setFilters(requestFilter);
        props.dispatch(taskActions.getTasks({
            token: Biscuit.get('token'),
            filter: requestFilter,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setTasksPending(true);
        props.dispatch(taskTypesActions.getTaskTypes({
            token: Biscuit.get('token'),
            filter: {
                'findForSelect': true
            },
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setTaskTypesPending(true);
        if(props["params"].id !== null){
            props.dispatch(taskActions.getTask({
                token: Biscuit.get('token'),
                id: props["params"].id,
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setTaskPending(true);
            props.dispatch(facilityActions.getFacilities({
                token: Biscuit.get('token'),
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setFacilitiesPending(true);
        }


    }

    if(!initialized){
        initialize();
    }

    const selectAll = (e,val) => {
        setAllSelected(val);
        let clone = {};
        Object.assign(clone,checkedItems);
        if(val){
            let paramValues = [];
            tasks.map(task => {
                paramValues.push(task.id);
                clone[task.id] = true;
            });
            searchParams.set('selected', paramValues.join('k'));
            searchParams.set('selectedall',true);
            setCheckedItems(clone);
            setOneItemChecked(true);
            setSelectedItems(paramValues.length);
        } else {
            setCheckedItems({});
            searchParams.delete('selected');
            searchParams.delete('selectedall');
            setOneItemChecked(false);
            setSelectedItems(0);
        }
        const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
        history.pushState(null, "", newRelativePathQuery);
    }

    let tabs =[
         {
            name: 'checkAll',
            mediumWidth: 1,
            smallWidth: 1,
            extraClasses: 'large-1',
            title: t('select all'),
            isCheckbox: true,
            value: allSelected,
            onChange: selectAll,
            label:"",
            checkBoxLabel: t('all'),
            checkBoxStyle: {paddingTop: "7%"},
            style: {minWidth: "170px", paddingLeft: "2.5%"}
        }, {
        name: t('task_nbr',null,'capital'),
        mediumWidth: 1,
        smallWidth: 1,
        extraClasses: 'large-1',
        title: t('sort_by_${a}',{a:t('task_nbr')},'capital'),
        canSort: true,
        style:{marginLeft:"-2.5%"},
        sort: {
            direction: (sort.sort === 'task_nbr'?sort.direction:'desc'),
            data_inb_val: 'task_nbr'
        },
            preselected: (sort.sort === 'task_nbr')
        },{
        name: t('designation',null,'capital'),
        mediumWidth: 2,
        smallWidth: 2,
        extraClasses: 'large-2',
        title: t('sort_by_${a}',{a:t('name')},'capital'),
        canSort: true,
        sort: {
            direction: (sort.sort === 'designation'?sort.direction:'asc'),
            data_inb_val: 'name'
        },
            preselected: (sort.sort === 'designation')
        },{
        name: t('assigned',null,'capital'),
        mediumWidth: 2,
        smallWidth: 2,
        extraClasses: 'large-2',
        title: t('assignment',null,'capital'),
        canSort: false
    },{
        name: t('created_at',null,'capital'),
        mediumWidth: 2,
        smallWidth: 2,
        extraClasses: 'large-2',
        title: t('sort_by_${a}',{a:t('created')},'capital'),
        canSort: true,
        sort: {
            direction: (sort.sort === 'created'?sort.direction:'desc'),
            data_inb_val: 'created'
        },
        preselected: (sort.sort === 'created')             // aware of preselecting only one tab!!
    }, {
        name: t('done_until') + ' ' + t('till'),
        mediumWidth: 2,
        smallWidth: 2,
        extraClasses: 'large-2',
        title: t('sort_by_${a}',{a:t('end')},'capital'),
        canSort: true,
        sort: {
            direction: (sort.sort === 'end'?sort.direction:'asc'),
            data_inb_val: 'end'
        },
            preselected: (sort.sort === 'end')
        }, {
        name: t('status',null,'capital'),
        mediumWidth: 2,
        smallWidth: 2,
        extraClasses: 'large-1',
        title: t('status',null,'capital'),
        canSort: false
    }];
    const _queryState = {
        timeStamp: 0,
        value: ""
    }
    const searchBarHandler = (ev) => {
        let query;
        if(typeof ev.target !== 'undefined') {
            query = ev.target.value.toLowerCase();
        } else {
            query = '';
        }
        searchParams.delete('task_nbr');
        if(query !== '') {
            searchParams.set('task_nbr', query);
        }
        const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
        history.pushState(null, "", newRelativePathQuery);
        let standardFilter = {
            sort: "task_nbr",
            direction: "desc",
            page: 1,
            limit: paginationLimit
        };
        const minLength = 1;
        let filterA = standardFilter;
        setResetFilter(true);
        if (query.length >= minLength) {                                    // work user search only for values bigger or equal to the minimum length

            setTimeout(function () {

                let diff = Number(moment().format('x')) - _queryState.timeStamp;

                if (diff > 700 && _queryState.value === query) {                  // no changes after the last 700 ms -> user finished input -> start request
                    onFilterChanged({
                        ...filterA,
                        'task_nbr': query
                    });

                }
            },800);
        } else {
            onFilterChanged(filterA);
        }
        _queryState.timeStamp = Number(moment().format('x'));
        _queryState.value = query;

    };

    const onCheckBox = (e,id) => {
       let clone = {};
       Object.assign(clone,checkedItems);
        searchParams.delete('selectedall');
        setAllSelected(false);
       clone[id] = e.target.checked;

           let params=[];
           Object.keys(clone).map(id => {
               if(clone[id]){
                   params.push(id);
               }
           });
           if(params.length < 1){
               searchParams.delete('selected');
               searchParams.delete('selectedall');
           } else {
               if(tasks.length === params.length){
                   searchParams.set('selectedall',true);
                   searchParams.delete('selected');
                   setAllSelected(true);
               }else {
                   searchParams.set('selected', params.join('k'));
               }

           }
        const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
        history.pushState(null, "", newRelativePathQuery);
       setCheckedItems(clone);
        setOneItemChecked(false);
        let count = 0;
       Object.keys(clone).map((val, key) => {
           if(clone[val]){
               setOneItemChecked(true);
               count++;
           }
       });
       setSelectedItems(count);
    }

    const multiDelete = (e,val) => {
        let datas = [];
        if(!oneItemChecked){ return; }
        Object.keys(checkedItems).map((val,key)=> {
            if(checkedItems[val]) {
                datas.push({id: Number(val)});
            }
        });
        if(confirm(t('really_delete_${a}_${b}',{a:selectedItems,b:(selectedItems>1?t('tasks'):t('task'))}))) {
            setAction('deleted');
            props.dispatch(taskActions.bulk({
                token: Biscuit.get('token'),
                body: {
                    action: 'delete',
                    data: datas
                },
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setSelectedItems(0);
            searchParams.delete('multiselect');
            setCheckedItems({});
            searchParams.delete('selected');
            searchParams.delete('selectedall');
            setOneItemChecked(false);
            setAllSelected(false);
            setBulkPending(true);
        }
    }
    const multiEdit = (e,val) => {
       if(shouldSave){
           let datas = [];
           Object.keys(checkedItems).map((val,key)=> {
               if(checkedItems[val]) {
                   if (typeof tasks === 'object') {
                       Object.keys(tasks).map((n) => {
                           if (tasks[n].id === Number(val)) {
                               datas.push(tasks[n]);
                           }
                       });
                   } else {
                       tasks.map(ta => {
                           if (ta.id === Number(val)) {
                               datas.push(ta);
                           }
                       })
                   }
               }
           });
           if(datas.length > 0) {
               setAction('edited');
               props.dispatch(taskActions.bulk({
                   token: Biscuit.get('token'),
                   body: {
                       action: 'edit',
                       data: datas
                   },
                   parameters: {
                       headers: {
                           'Accept-Language': language,
                           'Content-Language': language
                       }
                   }
               }));
               setSelectedItems(0);
               searchParams.delete('multiselect');
               setCheckedItems({});
               searchParams.delete('selected');
               searchParams.delete('selectedall');
               setOneItemChecked(false);
               setAllSelected(false);
               setBulkPending(true);
               setShouldSave(false);
           }
       } else {
           setShowMultiEditDialog(true);
           searchParams.set('multiedit',true);
       }
        const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
        history.pushState(null, "", newRelativePathQuery);
    }

    const cleanString = (val) => {
        if(val.contains("%3D")){
            let temp = val.split('%3D');
            return temp[0];
        }
        return val;
    }



    return (
        <>
            {!taskTypesPending  && <TaskSidebar
                tasks={tasks}
                //setSelectedFilter={onFilterChanged}
                taskTypes={taskTypes}
                globalFilter={filters}
                setGlobalFilter={onFilterChanged}
                summary={summary}
                summaryPending={summaryPending}
                resetFilter={resetFilter}
            />}
            <div id="inb-c-main" className="columns">
                <InboomaSubmenu
                    searchbar={true}
                    searchbarPlaceholder={t('task_nbr',null,'capital')}
                    extraClasses={"sticky-top"}
                    searchbarValue={allUrlParamsClone?.task_nbr !== undefined ? allUrlParamsClone.task_nbr : ""}
                    searchbarHandler={searchBarHandler}
                    smallOnlyTitle={t("tasks",null,'capital')}
                    pagination={pagination}
                    itemsCountPerPage={paginationLimit}
                    pageRangeDisplayed={5}
                    onChange={loadNextPage}
                    initialized={initialized}
                    itemLength={tasks.length}
                    multiSelect={true}
                    //setPaginationLimit={setPaginationLimit}
                    oneItemChecked={oneItemChecked}
                    selectedItemsCount={selectedItems}
                    model={t('tasks')}
                    multiSwitchOptions={[
                        oneItemChecked && {
                            label: t('delete'),
                            multiEvent: multiDelete,
                            value: null
                        },
                        oneItemChecked && {
                            label: t('edit'),
                            multiEvent: multiEdit,
                            value: null
                        },
                        oneItemChecked && {
                            label: t('select none'),
                            multiEvent: selectAll,
                            value: false
                        },
                    ]}
                />

                <SortNav
                        tabs={tabs}
                        listStyle="tight"
                        extraClasses={"sticky-top-sortbar"}
                        handler={onChangeSort}/>
                {/* {initialized && tasks.length > 0 && !tasksPending && typeof pagination !== 'undefined' &&
                    <Paginator
                        pagination={pagination}
                        itemsCountPerPage={paginationLimit}
                        pageRangeDisplayed={5}
                        onChange={loadNextPage}
                    />}*/}
                <div className="off-canvas-wrapper">
                {initialized && !tasksPending && tasks.length > 0 &&
                <TasksList
                    tasks={tasks}
                    task={task}
                    dispatch={props.dispatch}
                    filterChangedHandle={onFilterChanged}
                    filter={filters}
                    userQueue={userQueue}
                    setUserQueue={setUserQueue}
                    extraUsers={extraUsers}
                    rbac={rbac}
                    loadNextPage={loadNextPage}
                    onRemoveTask={onRemoveTask}
                    onChangeItemStatus={onChangeItemStatus}
                    tasksPending={tasksPending}
                    checkedItems={checkedItems}
                    onCheckBox={onCheckBox}
                />}
                </div>
                {initialized && (tasks.length < 1 || typeof tasks.length === 'undefined') &&
                <>
                    <div
                        id="inb-app-collection-empty"
                        className="inb-announcement">
                        <div className="inb-image-box">
                            <img alt="No Data" src={"assets/img/no_data.svg"}/>
                        </div>
                        <h3>
                            { t('app_msg_collection_empty') }
                        </h3>
                        <p>
                            { t('app_msg_collection_empty_body') }
                        </p>
                    </div>
                </>
                }
                {/* {initialized && tasks.length > 0 && !tasksPending && typeof pagination !== 'undefined' &&
                    <Paginator
                        pagination={pagination}
                        itemsCountPerPage={paginationLimit}
                        pageRangeDisplayed={5}
                        onChange={loadNextPage}
                    />} */}

                {tasksPending  && <Loader
                    mediumWidth={2}
                    smallWidth={4}
                    subLoaders={5}/>}
            </div>

            {((props["params"].add || props["params"].id !== null) && !taskPending && !tasksPending && !facilitiesPending) &&
            <ItemView
                onClose={onCloseTask}
                dispatch={props.dispatch}
                resources={props.resources}
                getUserNameById={Functions.getUserNameById}
                getUserLabel={Functions.getUserLabel}
                getObjectReference={Functions.getObjectReference}
                getLabelStringOfModel={Functions.getLabelStringOfModel}
                userQueue={userQueue}
                setUserQueue={setUserQueue}
                extraUsers={extraUsers}
                task={task}
                tasks={tasks}
                facilities={facilities}
                requestPath={props.params.returnPath}
                showNotification={props.showNotification}
                lead={props.params.lead}
                fk_model={props.params.fk_model}
                fk_id={props.params.fk_id}
                userReady={userReady}
                setFilter={setFilters}
                filter={filters}
                allUrlParams={allUrlParams}
            />
            }
            {showMultiEditDialog && initialized && <MultiEditDialog
                handleCloseDialog={handleCloseDialog}
                fields={fields}
                fieldTypes={fieldTypes}
                selectFields={selectFields}
                selectedIds={checkedItems}
                entities={tasks}
                setEntities={setTasks}
                setShouldSave={setShouldSave}
                fieldLabels={fieldLabels}
                hasSuperSelect={hasSuperSelect}
                dispatch={props.dispatch}
                shouldSave={shouldSave}
                />}
        </>
    );
}

export default TasksView;